module.exports = __webpack_public_path__ + "static/bbis-hero-2-a56d0f8c3f02a6f4c8d732b764bfa965.jpg";